export class ViewPathConstants {
  // Root
  landingViewPath = "/";

  // Public Routes
  loginViewPath = "/auth";
  blogsViewPath = "/blogs";
  blogDetailViewPath = "/blog/:id";
  contactViewPath = "/contact";
  privacyPolicyViewPath = "/privacy-policy";
  pageNotFoundViewPath = "/page-not-found";

  // Authenticated Routes
  dashboardViewPath = "/dashboard";
  settingsViewPath = "/settings";

  //holiday
  holidayCalenderViewPath = "/holiday-calender";
  holidayAddViewPath = `${this.holidayCalenderViewPath}/add`;
  holidayEditViewPath = `${this.holidayCalenderViewPath}/edit`;

  // Admin (role-protected)
  adminDashboardViewPath = "/admin";
  adminAnalyticsViewPath = "/admin/analytics";
  adminBlogsViewPath = "/admin/blogs";
  adminProfileViewPath = "/admin/profile";
  adminBlogEditViewPath = "/admin/blog/:id/edit";
}

const viewpaths = new ViewPathConstants();
export default viewpaths;
